// Slick Carousel
import Glide from "@glidejs/glide";

class CarouselHeroCaption {
  constructor() {
    // element that will be wrapped
    const carousel = document.querySelector(".carousel-hero-caption");

    if (carousel) {
      const carouselTrack = document.querySelector(
        ".carousel-hero-caption .wp-block-group"
      );
      const carouselSlides = carouselTrack.querySelector(
        ".carousel-hero-caption .wp-block-group .wp-block-group"
      );
      const carouselIndividualSlide = carouselTrack.querySelectorAll(
        ".carousel-hero-caption .wp-block-group .wp-block-group .wp-block-cover"
      );

      // Add Glide classes
      carouselTrack.classList.add("glide__track");
      carouselTrack.dataset.glideEl = "track";
      carouselSlides.classList.add("glide__slides");
      carouselIndividualSlide.forEach((item) => {
        item.classList.add("glide__slide");
      });

      // count how many slides there are
      const dotCount = carouselIndividualSlide.length

      // Generate the HTML for the navigation dots
      let dotHTML = ""
      for (let i = 0; i < dotCount; i++) {
        dotHTML += `<button class="slider__bullet glide__bullet" data-glide-dir="=${i}"><i class="fa-regular fa-circle"></i><i class="fa-solid fa-circle"></i></button>`
      }

      // Add the dots container
      carouselTrack.insertAdjacentHTML("afterend",
      `<div class="glide__bullets" data-glide-el="controls[nav]"></div>`
      )

      // Add the dots HTML to the DOM
      document.querySelector(".glide__bullets").insertAdjacentHTML("beforeend", dotHTML)

      // Tweak styles
      carousel.style.overflow = "hidden";
      carouselSlides.style.flexWrap = "nowrap";

      var fullWidthGlide = new Glide(".carousel-hero-caption", {
        type: "carousel",
        perView: 1,
        autoplay: 4000,
        peek: 0,
        gap: 0,
      }).mount();
    }
  }
}

export default CarouselHeroCaption;
